/**
 * 控制
 * pinia
 * 本地資料庫持久化 (sessionStorage)
 *
 * 與同目錄 index.ts (localStorage) 的差別只有 storage：
 * 用於「只需存活於本次登入 / 本瀏覽器分頁」的狀態，例如列表頁查詢條件保留。
 */

const PiniaPersistSessionConfiguration = (key) => {
    const persist = {
        key,
        storage: window.sessionStorage
    };
    return persist;
};

export default PiniaPersistSessionConfiguration;
